var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionShareScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-824.000000, -1572.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Share-screen",
    transform: "translate(824.000000, 1572.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1349697,5.1411045 L14.1349697,8.0858891 L2.9447854,8.0858987 L2.9447854,24.7730668 L28.4662564,24.7730668 L28.4662564,20.0613492 L31.4110425,20.0613492 L31.4110425,25.7546647 C31.4110425,27.8362821 29.7908357,29.539758 27.7428067,29.672704 L27.4846623,29.6810601 L0,29.6810601 L0,9.0674842 C0,6.9849375 1.6202067,5.2823284 3.6682346,5.149452 L3.9263804,5.1411045 L14.1349697,5.1411045 Z M32,2 L32,16.7239259 C29.7953377,16.7239259 28.0078506,14.9364405 28.0078506,12.7327604 L28.0078506,12.7327604 L28.0078506,8.8142331 L20.0991401,16.7239259 L17.2760734,13.9008592 L25.1857662,5.991166 L21.2682209,5.991166 C19.0635586,5.991166 17.2760734,4.2046627 17.2760734,2 L17.2760734,2 L32,2 L32,2 Z",
    id: 278
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionShareScreen);
export default __webpack_public_path__ + "static/media/navigation-and-action-share-screen.07596180.svg";
export { ForwardRef as ReactComponent };